import { render, staticRenderFns } from "./VCC.vue?vue&type=template&id=90114648&scoped=true&"
import script from "./VCC.vue?vue&type=script&lang=js&"
export * from "./VCC.vue?vue&type=script&lang=js&"
import style0 from "./VCC.vue?vue&type=style&index=0&id=90114648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90114648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VContainer,VIcon,VImg,VRow})
